import { setDefaultAssets } from '@leagueplatform/asset-config';
import { FHIR_QUESTIONNAIRE_MODULE_ASSETS_MAP } from './asset-map';

export const initModule = () => {
  setDefaultAssets(FHIR_QUESTIONNAIRE_MODULE_ASSETS_MAP);
};
